import getInstanceAxios from './RequestGlobalConfig';

export default getInstanceAxios(process.env.REACT_APP_BASE_AUTHENTICATOR_V2_API_URL);
